import { WeatherCode, WeatherIcon } from "../models";

export const fromWeatherCodeToWeatherIcon = (code: WeatherCode): WeatherIcon => {
  switch (code) {
    case '01d':
      return 'sunny';
    case '01n':
      return 'moon';
    case '02d':
    case '02n':
      return 'partly-cloudy';
    case '03d':
    case '03n':
      return 'cloudy';
    case '04d':
    case '04n':
      return 'windy';
    case '09n':
      return 'rainy';
    case '09d':
      return 'sun-shower';
    case '10d':
    case '10n':
      return 'rainy';
    case '11d':
    case '11n':
      return 'rainy';
    case '13d':
    case '13n':
      return 'snowy';
    case '50d':
    case '50n':
      return 'windy';
  }
};

export const fromWeatherCodeToWeatherBackground = (code: WeatherCode): string => {
  switch (code) {
    case '01d':
      return 'linear-gradient(90deg, rgb(32, 148, 255, 0.6), rgb(89, 184, 255, 0.6))';
    case '01n':
      return 'linear-gradient(90deg, rgb(32, 148, 255, 0.6), rgb(89, 184, 255, 0.6))';
    case '02d':
      return 'linear-gradient(90deg, rgb(32, 148, 255, 0.6), rgb(89, 184, 255, 0.6))';
    case '02n':
      return 'linear-gradient(90deg, rgb(32, 148, 255, 0.6), rgb(89, 184, 255, 0.6))';
    case '03d':
      return 'linear-gradient(90deg, rgb(32, 148, 255, 0.6), rgb(89, 184, 255, 0.6))';
    case '03n':
      return 'linear-gradient(90deg, rgb(32, 148, 255, 0.6), rgb(89, 184, 255, 0.6))';
    case '04d':
      return 'linear-gradient(90deg, rgb(32, 148, 255, 0.6), rgb(89, 184, 255, 0.6))';
    case '04n':
      return 'linear-gradient(90deg, rgb(32, 148, 255, 0.6), rgb(89, 184, 255, 0.6))';
    case '09n':
      return 'linear-gradient(90deg, rgb(32, 148, 255, 0.6), rgb(89, 184, 255, 0.6))';
    case '09d':
      return 'linear-gradient(90deg, rgb(32, 148, 255, 0.6), rgb(89, 184, 255, 0.6))';
    case '10d':
      return 'linear-gradient(90deg, rgb(32, 148, 255, 0.6), rgb(89, 184, 255, 0.6))';
    case '10n':
      return 'linear-gradient(90deg, rgb(32, 148, 255, 0.6), rgb(89, 184, 255, 0.6))';
    case '11d':
      return 'linear-gradient(90deg, rgb(32, 148, 255, 0.6), rgb(89, 184, 255, 0.6))';
    case '11n':
      return 'linear-gradient(90deg, rgb(32, 148, 255, 0.6), rgb(89, 184, 255, 0.6))';
    case '13d':
      return 'linear-gradient(90deg, rgb(32, 148, 255, 0.6), rgb(89, 184, 255, 0.6))';
    case '13n':
      return 'linear-gradient(90deg, rgb(32, 148, 255, 0.6), rgb(89, 184, 255, 0.6))';
    case '50d':
      return 'linear-gradient(90deg, rgb(32, 148, 255, 0.6), rgb(89, 184, 255, 0.6))';
    case '50n':
      return 'linear-gradient(90deg, rgb(32, 148, 255, 0.6), rgb(89, 184, 255, 0.6))';
  }
};
